<template>
    <span class="ani-number">{{ animationNumber }}</span>
</template>

<script>
import { gsap } from "gsap";
export default {
    props: {
        num: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            tweenedNumber: 0,
        };
    },
    computed: {
        animationNumber() {
            return Number(this.tweenedNumber).toFixed(0);
        },
    },
    mounted() {
        gsap.to(this.$data, { duration: 5, tweenedNumber: this.num })
        // gsap.to(".ani-number", {
        //     x: 600,
        //     duration: 1,
        //     delay: 0.5,
        //     ease: "power2.inOut"
        // })
    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.ani-number {
    font-size: 48px;
    color: @primaryColor;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/AniNumber.vue